module.exports = {
    api: 'https://app.formulir.com/api/',
    isDev: false,
    baseUrl: 'https://form.id',
    googleCaptchaKey: '8133ec97-b0eb-43fe-bbc4-710ea27745c5',
    redirectUrl: 'https://form.id/',
    imagekit:{
        thumbnail:"https://media.form.id/gcs/tr:n-ik_thumbnail",
        medium: "https://media.form.id/gcs/tr:n-ik_medium",
        full:"https://media.form.id/gcs/tr:n-ik_full/",
    },
    shippingUrl:"https://app.mengantar.com/api/",
    webCacheURL: 'https://cache.form.id',
    orderHmacSecret: "formulir2021"
}
